import { AlertCircle } from "lucide-react";

interface MutationErrorBannerProps {
  message: string | null | undefined;
}

/**
 * Inline error banner for mutation failures inside dialogs and drawers.
 * Renders nothing when `message` is null/undefined. Uses theme tokens so the
 * styling tracks light/dark mode automatically.
 */
export function MutationErrorBanner({ message }: MutationErrorBannerProps) {
  if (!message) return null;
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/10 p-3 text-sm text-destructive"
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="leading-snug">{message}</span>
    </div>
  );
}
